module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('hgroup', [_c('h1', {
    staticClass: "FMH"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_v",
      "title": "v"
    }
  }, [_c('samp', {
    staticClass: "SANS-MetaBook-Roman-11"
  }, [_vm._v("CONTENTS")])])])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    staticClass: "CFMH",
    attrs: {
      "id": "c_ter"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/terminology#ter"
    }
  }, [_c('span', {
    staticClass: "list-text1"
  }, [_vm._v("A Note on Terminology")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT",
    attrs: {
      "id": "c_int"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#int"
    }
  }, [_c('span', {
    staticClass: "list-text"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter_1#ch1"
    }
  }, [_c('span', {
    staticClass: "list-num"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "list-text"
  }, [_vm._v("The Storyteller and the Sultan of France")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list-num"
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "list-text"
  }, [_vm._v("Marvellous Thieves")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list-num"
  }, [_vm._v("3")]), _vm._v(" "), _c('span', {
    staticClass: "list-text"
  }, [_vm._v("The Empire of English")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list-num"
  }, [_vm._v("4")]), _vm._v(" "), _c('span', {
    staticClass: "list-text"
  }, [_vm._v("The Magician’s Interpreter")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list-num"
  }, [_vm._v("5")]), _vm._v(" "), _c('span', {
    staticClass: "list-text"
  }, [_vm._v("The Wiles of Women")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list-num"
  }, [_vm._v("6")]), _vm._v(" "), _c('span', {
    staticClass: "list-text"
  }, [_vm._v("Stealing with Style")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list-num"
  }, [_vm._v("7")]), _vm._v(" "), _c('span', {
    staticClass: "list-text"
  }, [_vm._v("The False Caliph")])])]), _vm._v(" "), _c('li', {
    staticClass: "CBMH1",
    attrs: {
      "id": "c_not"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#not",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list-text1"
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('li', {
    staticClass: "CBMH",
    attrs: {
      "id": "c_ack"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list-text1"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('li', {
    staticClass: "CBMH",
    attrs: {
      "id": "c_ill"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/illustration#ill",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list-text1"
  }, [_vm._v("Illustration Credits")])])]), _vm._v(" "), _c('li', {
    staticClass: "CBMH",
    attrs: {
      "id": "c_ind"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list-text1"
  }, [_vm._v("Index")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0